import { IconName } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import AddAppModule from './AddAppModule'
import SuggestionChipsForService from './SuggestionChipsForService'

type TargetItem = {
  value: string
  label: string
  color: string
  icon: IconName
}

type Suggestion = {
  values: { id: number, name: string }[]
  legendBackground?: string
}

type ServiceConditionProps = {
  targetItem: TargetItem
  services: { id: number, name: string }[]
  serviceCandidates: { id: number, name: string }[]
  imitations: string[]
  onServicesChange: (services: { id: number, name: string }[]) => void
  suggestion?: Suggestion
  disabled?: boolean
}

const ServiceCondition: FC<ServiceConditionProps> = (props) => {
  const {
    targetItem,
    services,
    serviceCandidates,
    imitations,
    onServicesChange,
    suggestion,
    disabled,
  } = props

  return (
    <>
      <div className="condition_header">
        <div className="condition_label">
          <FontAwesomeIcon
            icon={['fas', targetItem.icon as IconName]}
            style={{ color: targetItem.color }}
          />
          {targetItem.label}
        </div>
      </div>
      <div>
        <div className="detail_box">
          {
            services.map((value) => (
              <div
                className="chip"
                style={{ backgroundColor: imitations.includes(value.name) ? "#ffd2d2" : "#dddddd" }}
                key={`condition_${value.name}`}
              >
                {value.name}
                <span
                  className="chip_remove"
                  onClick={() => onServicesChange(services.filter((w) => w.id !== value.id))}
                  role="none"
                >
                  <FontAwesomeIcon icon={['fas', 'times']} />
                </span>
              </div>
            ))
          }
          <AddAppModule
            selectList={services}
            serviceList={serviceCandidates}
            callbackApps={(apps) => onServicesChange(apps)}
            disabled={disabled}
          />
        </div>
      </div>
      <div>
        <div className="note_list">
          <div className="note">
            {`※ 指定アプリケーション${services.length > 1 ? "のいずれか" : ""}が含まれている場合、自動仕分けされます。`}
          </div>
        </div>
      </div>
      {
        !!suggestion?.values.length && (
          <SuggestionChipsForService
            values={suggestion.values}
            selectedValues={services}
            onToggle={(v) => onServicesChange(
              services.map((w) => w.id).includes(v.id) ? services.filter((s) => s.id !== v.id) : [...services, v],
            )}
            legendBackground={suggestion.legendBackground}
          />
        )
      }
    </>
  )
}

export default ServiceCondition
